import { useAtomValue } from 'jotai';
import { Outlet } from 'react-router';
import { useUserAccounts } from '@/hooks/use-user-accounts';
import { goldenMeQueryAtom } from '@/modules/sentinel-workspace/benchmark/benchmark-state';
import SecondarySidebarLayout, { type SecondarySidebarItem } from './secondary-sidebar-layout';

const ITEMS: SecondarySidebarItem[] = [
  { label: 'Tickets', path: '/sentinel-workspace' },
  { label: 'Benchmark', path: '/sentinel-workspace/benchmark' },
];

/** The Sentinel sidebar, for Benchmark editors and the Sentinels of the selected account. Anyone else (and anyone when the
 * check fails) gets the page alone, as before Benchmark had a page of its own. Nothing renders until the check answers, so
 * the page mounts once, already in its final layout: adding the sidebar later would remount the ticket workspace. */
export default function SentinelLayout() {
  const check = useAtomValue(goldenMeQueryAtom);
  const { currentAccountId } = useUserAccounts();
  if (check.isPending) return null;
  const me = check.data;
  const hasBenchmark =
    me?.role === 'editor' || (me?.role === 'sentinel' && currentAccountId !== null && me.accounts.includes(currentAccountId));
  if (!hasBenchmark) return <Outlet />;
  return <SecondarySidebarLayout title='Sentinel' items={ITEMS} />;
}
